import day1NPC from '@/config/NPCConfigs/day1NPC';
import day2ANPC from '@/config/NPCConfigs/day2ANPC';
import day2BNPC from '@/config/NPCConfigs/day2BNPC';
import type { NPCConfig } from '@/entities';

export interface DayNPCConfig {
  name: string;
  configs: Record<number, NPCConfig>; // day number -> NPC config
}

// Day 1 configurations
export const day1NPCs: NPCConfig[] = day1NPC;

// Day 2 configurations - NPCs have different dialogs and some moved positions
export const day2BNPCs: NPCConfig[] = day2BNPC;

// Day 3 configurations - More dramatic changes, some NPCs missing, new ones appeared
export const day2ANPCs: NPCConfig[] = day2ANPC;

// Legacy export for backwards compatibility
export const npcConfigs: NPCConfig[] = [];
